import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from './components/components.module';
import { CommonModulePageModule } from './pages/common-module/common-module.module';
import { HomePageModule } from './pages/home/home.module';
import { LoginPageModule } from './pages/login/login.module';
import { SettingsPageModule } from './pages/settings/settings.module';
import { PrivateRoutingModule } from './private-routing.module';
import { PrivateComponent } from './private.component';


@NgModule({
  imports: [
    PrivateRoutingModule,
    CommonModule,
    IonicModule,
    ComponentsModule,

    HomePageModule,
    LoginPageModule,
    SettingsPageModule,

    CommonModulePageModule,
  ],
  declarations: [
    PrivateComponent
  ]
})
export class PrivateModule { }
